<!-- @format -->

<img
	#img
	[alt]="altText"
	[disableOptimizedSrcset]="false"
	[loaderParams]="imageLoaderConfig.loaderParams"
	[ngSrc]="imageLoaderConfig.src"
	[priority]="isPriority"
	[attr.loading]="getLoadingStrategy()"
	[sizes]="imageLoaderConfig.loaderParams?.sizes"
	fill
	(error)="handleImageError(img.src)"
	(load)="optimizedImageLoaded.emit($event)"
	itemprop="image"
/>

